import { ActionTree } from "vuex";
import { MasmenState } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<MasmenState, RootState> = {};
